import React, { useRef, useState } from "react";
import { useEffect } from "react";
import "./styles.scss";
import PDFIcom from "../../Assets/Images/pdfImg.png";
import sampleProfile from "../../Assets/Images/avator.png";
import uploadIcon from "../../Assets/Images/uploadIcon.svg";
import { FileUploader } from "react-drag-drop-files";
import InputBox from "Components/InputBox";
import { useDispatch, useSelector } from "react-redux";
import { MdDeleteOutline } from "react-icons/md";
import { multiUpload } from "../../Redux/Slices/User/userSlice";
import { LuCircle } from "react-icons/lu";
import Loader from "Components/Loader";
import ImageModal from "Components/ImageModal";
import DocIcon from "../../Assets/Images/doc.png";
import XlsIcon from "../../Assets/Images/xlsx.png";
import ReactQuill from 'react-quill-new';
import "quill/dist/quill.snow.css";
import { motion, AnimatePresence } from "framer-motion";
import { compressImage } from "Services/Utils/imageCompression";
import Button from "Components/Button";
import ImageEditorComp from "Components/ImageEditor";
import { Modal } from "react-bootstrap";


const slideVariants = {
  enter: (direction) => ({
    x: direction > 0 ? "100%" : "-100%",
    opacity: 0,
    position: "absolute",
    width: "100%",
  }),
  center: {
    x: 0,
    opacity: 1,
    position: "relative",
    width: "100%",
  },
  exit: (direction) => ({
    x: direction < 0 ? "100%" : "-100%",
    opacity: 0,
    position: "absolute",
    width: "100%",
  }),
};

const AssessmentAnswer = ({
  formMethods,
  categories,
  categoryIndex,
  subCategoryIndex,
  disabled,
  setIsTransitioning,
}) => {
  const noteLabel = {
    color: "#2E2E2E",
    fontSize: "16px",
    fontWeight: "600",
  };
  const isLoading = useSelector((state) => state.user.isLoading);
  const [direction, setDirection] = useState(0);
  const [hoveredRatingForModule, setHoveredRatingForModule] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadContext, setUploadContext] = useState(null);
  const MAX_CHARS = 100;
  const quillRefs = useRef([]);
  const questionsRef = useRef(null);
  const {
    setValue,
    formState: { errors },
    setError,
    clearErrors,
  } = formMethods;
  const dispatch = useDispatch();

  const buttonTitleStyle = {
    fontSize: "14px",
    fontWeight: "600",
  };

  const buttonStyle = {
    height: "44px",
    oultine: "none",
    border: "1px solid  #1f2155",
    width: "240px",
    marginTop: "20px",
    marginBottom: "20px",
    paddingTop : "4px",
    paddingBottom : "4px",
  };

  const buttonRecommendationStyle = {
    height: "44px",
    oultine: "none",
    border: "1px solid  #1f2155",
    width: "280px",
    marginTop: "20px",
    marginBottom: "20px"
  }

  useEffect(() => {
    clearErrors();
  }, [setValue, categories, categoryIndex, subCategoryIndex]);

  const handleChange = (questionIndex, e, name, index = null, nestedKey = null) => {
    const updatedData = [...categories];
    const question =
      updatedData[categoryIndex]?.sub_categories?.[subCategoryIndex]?.questions?.[questionIndex];

    if (!question) return;

    if (index !== null && nestedKey) {
      if (!Array.isArray(question[name])) {
        question[name] = [];
      }

      if (!question[name][index]) {
        question[name][index] =
          name === "recommendation"
            ? { files: [], recText: "" }
            : { files: [], description: "" };
      }

      question[name][index][nestedKey] = e.target.value;
    } else {
      question[name] = e.target.value;
    }

    setValue("categories", updatedData);

    clearErrors(
      index !== null
        ? `categories.${categoryIndex}.sub_categories.${subCategoryIndex}.questions.${questionIndex}.${name}.${index}.${nestedKey}`
        : `categories.${categoryIndex}.sub_categories.${subCategoryIndex}.questions.${questionIndex}.${name}`
    );
  };


  const handleFileChange = async (files, questionIndex, evidenceIndex, isRecommendation = false) => {
    if (!files || files.length === 0) return;

    const validExtensions = [".png", ".jpg", ".jpeg", ".pdf", ".docx", ".xlsx"];
    const MAX_FILE_SIZE = 5 * 1024 * 1024;

    const selectedFiles = Array.from(files);
    const nonImageFiles = [];

    const errorPath = isRecommendation
      ? `categories.${categoryIndex}.sub_categories.${subCategoryIndex}.questions.${questionIndex}.recommendation.${evidenceIndex}`
      : `categories.${categoryIndex}.sub_categories.${subCategoryIndex}.questions.${questionIndex}.evidence.${evidenceIndex}`;

    for (const file of selectedFiles) {
      const ext = "." + file.name.split(".").pop().toLowerCase();

      if (!validExtensions.includes(ext)) {
        setError(errorPath, {
          type: "manual",
          message: `Invalid file type: ${file.name}`,
        });
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        setError(errorPath, {
          type: "manual",
          message: `File ${file.name} exceeds the 5 MB size limit.`,
        });
        return;
      }

      if (file.type.startsWith("image/")) {
        setSelectedFile(file);
        setUploadContext({
          questionIndex,
          evidenceIndex,
          isRecommendation,
          errorPath,
        });
        return;
      }

      nonImageFiles.push(file);
    }

    if (nonImageFiles.length > 0) {
      uploadFiles(nonImageFiles, {
        questionIndex,
        evidenceIndex,
        isRecommendation,
        errorPath,
      });
    }
  };

  const uploadFiles = (files, context) => {
    const formData = new FormData();
    files.forEach((f) => formData.append("files", f));

    const { questionIndex, evidenceIndex, isRecommendation, errorPath } = context;

    const onUploadSuccess = (uploadedFiles) => {
      const updatedData = [...categories];
      const currentQuestion =
        updatedData[categoryIndex].sub_categories[subCategoryIndex].questions[questionIndex];

      const urls = uploadedFiles.map((f) => f?.url || "");

      if (isRecommendation) {
        if (!currentQuestion.recommendation[evidenceIndex]) {
          currentQuestion.recommendation[evidenceIndex] = { files: [], recText: "" };
        }
        currentQuestion.recommendation[evidenceIndex].files.push(...urls);
      } else {
        if (!currentQuestion.evidence[evidenceIndex]) {
          currentQuestion.evidence[evidenceIndex] = { files: [], description: "" };
        }
        currentQuestion.evidence[evidenceIndex].files.push(...urls);
      }

      setValue("categories", updatedData);
      clearErrors(errorPath);
    };

    dispatch(
      multiUpload({
        files: formData,
        callBack: onUploadSuccess,
      })
    );
  };



  const handleRemoveFile = (questionIndex, fileIndex, evidenceIndex, isRecommendation = false) => {
    const updatedData = [...categories];
    const currentQuestion = updatedData[categoryIndex].sub_categories[subCategoryIndex].questions[questionIndex];

    const target = isRecommendation
      ? currentQuestion.recommendation
      : currentQuestion.evidence;

    if (Array.isArray(target) && target[evidenceIndex] && Array.isArray(target[evidenceIndex].files)) {
      target[evidenceIndex].files.splice(fileIndex, 1);

      if (target[evidenceIndex].files.length === 0) {
        target[evidenceIndex].files = [];
      }
    }


    setValue("categories", updatedData);
  };

  const handleRecommendation = (e, questionIndex, recommendationIndex) => {
    const updatedData = [...categories];
    const recommendations =
      updatedData[categoryIndex].sub_categories[subCategoryIndex].questions[
        questionIndex
      ].recommendation;

    recommendations[recommendationIndex] = e.target.value;

    setValue("categories", updatedData);
  };

  const handleFinalScore = (score, questionIndex) => {
    const updatedData = [...categories];

    updatedData[categoryIndex].sub_categories[subCategoryIndex].questions[
      questionIndex
    ].finalScore = score;

    setValue("categories", updatedData);
  };

  const handleAddEvidence = (questionIndex) => {
    const updated = [...categories];
    const q =
      updated[categoryIndex].sub_categories[subCategoryIndex].questions[
      questionIndex
      ];

    if (!Array.isArray(q.evidence)) q.evidence = [];

    q.evidence.push({ files: [], description: "" });

    setValue("categories", updated);
  };

  const handleAddRecommendation = (questionIndex) => {
    const updated = [...categories];
    const q =
      updated[categoryIndex].sub_categories[subCategoryIndex].questions[
      questionIndex
      ];

    if (!Array.isArray(q.recommendation)) q.recommendation = [];

    q.recommendation.push({ files: [], recText: "" });
    setValue("categories", updated);
  };

  const handleDeleteRecommendation = (questionIndex, recommendationIndex) => {
    const updatedData = [...categories];
    const recommendations =
      updatedData[categoryIndex].sub_categories[subCategoryIndex].questions[
        questionIndex
      ].recommendation;

    recommendations.splice(recommendationIndex, 1);
    setValue("categories", updatedData);
  };

  const handleDeleteItem = (questionIndex, index, isRecommendation = false) => {
    const updated = [...categories];
    const q =
      updated[categoryIndex].sub_categories[subCategoryIndex].questions[
      questionIndex
      ];

    if (isRecommendation) {
      if (Array.isArray(q.recommendation) && q.recommendation[index]) {
        q.recommendation.splice(index, 1);
      }
    } else {
      if (Array.isArray(q.evidence) && q.evidence[index]) {
        q.evidence.splice(index, 1);
      }
    }

    setValue("categories", updated);
  };



  const getScoreClass = (score, questionIndex) => {
    const selectedScore =
      categories[categoryIndex]?.sub_categories[subCategoryIndex]?.questions[
        questionIndex
      ]?.finalScore;
    return selectedScore === score ? "selected-score" : "";
  };

  const isAdditionalInsights =
    subCategoryIndex === categories[categoryIndex]?.sub_categories?.length - 2;

  const isLastSubCategory =
    subCategoryIndex === categories[categoryIndex]?.sub_categories?.length - 1;

  const additionalInsightsData =
    categories[categoryIndex]?.sub_categories[subCategoryIndex]
      ?.additionalInsightsData;
  const feedbackData = categories[categoryIndex]?.sub_categories[subCategoryIndex]?.feedbackData

  const validAdditionalInsights = additionalInsightsData?.filter((item) => item?.comments?.trim()?.length > 0 || item?.mediaFiles?.length > 0) || []
  const validFeedbackData = feedbackData?.filter((item) => item?.comments?.trim()?.length > 0 || (item?.rating ?? 0) > 0) || []


  const StyledPoints = ({ points }) => (
    <span style={{ color: "#2e2e2e", fontWeight: 600 }}> - {points}</span>
  );


  const getAnswerText = (list) => {
    const elements = [];

    if (list?.subOption) {
      elements.push(
        <span key="subOption">
          {list.subOption.title}
        </span>
      );
    }

    if (list?.options?.title) {
      elements.push(
        <span key="option">
          {list.options.title}
          <StyledPoints points={list.points} />
        </span>
      );
    }

    if (list?.text_answer) {
      elements.push(
        <span key="text">
          {list.text_answer}
        </span>
      );
    }

    return elements.map((el, idx) => (
      <React.Fragment key={idx}>
        {el}
        <br />
      </React.Fragment>
    ));
  };

  const getGreaseInfo = (list) => {
    if (list?.grease_name) {
      return (
        <span>
          {list.grease_name}
          <StyledPoints points={list.points} />
        </span>
      );
    }

    if (list?.grease_size) {
      return (
        <span>
          {list.grease_size}
          <StyledPoints points={list.points} />
        </span>
      );
    }

    return null;
  };



  const groupUserAnswers = (item) => {
    const groupItems = {}
    item?.userAnswer?.forEach((it) => {
      if (!groupItems[it?.user_id]) {
        groupItems[it?.user_id] = [];
      }
      groupItems[it.user_id].push(it)
    })

    return groupItems;
  }



  // useEffect(() => {
  //   quillRefs.current.forEach((ref) => {
  //     if (!ref) return;

  //     const quill = ref.getEditor();
  //     if (!quill) return;

  //     const handler = () => {
  //       const text = quill.getText().trimEnd();
  //       if (text.length > MAX_CHARS) {
  //         quill.deleteText(MAX_CHARS, text.length);
  //       }
  //     };

  //     quill.on("text-change", handler);

  //     // cleanup per editor
  //     return () => {
  //       quill.off("text-change", handler);
  //     };
  //   });
  // }, [evidences.length])





  return (
    <div className="p-2">
      <div style={{ position: "relative" }}>
        <AnimatePresence custom={direction} mode="wait">
          <motion.div
            key={subCategoryIndex}
            custom={direction}
            variants={slideVariants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{ type: "tween", duration: 0.4 }}
            style={{ position: "absolute", top: 0, left: 0, width: "100%" }}
            ref={questionsRef}
            className="questions-container"
            onAnimationStart={() => setIsTransitioning(true)}
            onAnimationComplete={() => {
              setTimeout(() => {
                setIsTransitioning(false);
              }, 400)
            }}
          >
            <div className="question-answer-wrap">
              {isAdditionalInsights ? (
                <>
                  <div className="question">Additional insights</div>
                  <div>
                    {validAdditionalInsights?.length > 0 ? (
                      <>
                        {validAdditionalInsights?.map((item) => {
                          return (
                            <div className="additionalContentWrap my-3">
                              <div className="d-flex align-items-center mt-2 mb-3">
                                {item?.user?.profile_image ? (
                                  <img
                                    src={item?.user?.profileImage}
                                    alt={item?.userName}
                                  />
                                ) : (
                                  <img
                                    src={sampleProfile}
                                    alt="profile"
                                    className="reviewProfileImage"
                                  />
                                )}
                                <div className="answeredMemberName mx-3">
                                  {item?.userName}
                                </div>
                              </div>
                              <div>
                                <div className="additionalTitle">Media files</div>
                                {item?.mediaFiles?.length > 0 ? (
                                  <div className="mediaFilesWrap">
                                    {item?.mediaFiles?.map((list) => {
                                      const isPDF = list.toLowerCase().endsWith(".pdf");
                                      const isDoc = list.toLowerCase().endsWith(".docx");
                                      const isXls = list.toLowerCase().endsWith(".xlsx");
                                      return (
                                        <div key={list} className="my-2">
                                          {isPDF ? (
                                            <div className="pdf-container">
                                              <div className="individual-pdf-container">
                                                <a href={list} target="_blank" rel="noopener noreferrer">
                                                  <img src={PDFIcom} alt="PDF" width="75px" height="auto" />
                                                  <p>Open PDF</p>
                                                </a>
                                              </div>
                                            </div>
                                          ) : isDoc ? (
                                            <div className="pdf-container">
                                              <div className="individual-pdf-container">
                                                <a href={list} target="_blank" rel="noopener noreferrer">
                                                  <img src={DocIcon} alt="Doc" width="75px" height="auto" />
                                                  <p>Open Doc</p>
                                                </a>
                                              </div>
                                            </div>
                                          ) : isXls ? (
                                            <div className="pdf-container">
                                              <div className="individual-pdf-container">
                                                <a href={list} target="_blank" rel="noopener noreferrer">
                                                  <img src={XlsIcon} alt="Xlsx" width="75px" height="auto" />
                                                  <p>Open Xlsx</p>
                                                </a>
                                              </div>
                                            </div>
                                          ) : (
                                            <ImageModal src={list} alt={`file-${list}`} />
                                          )}
                                        </div>
                                      );
                                    })}

                                  </div>
                                ) : (
                                  <br />
                                )}
                              </div>

                              <div>
                                <label className="additionalTitle">Comments</label>
                                <div className="additionalComments">
                                  {item?.comments ?? ""}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </>
                    ) : (
                      <div>No Additonal Insights</div>
                    )}
                  </div>
                </>
              ) : isLastSubCategory ? (
                <>
                  <div className="question">Feedback</div>
                  <div>
                    {validFeedbackData?.length > 0 ? (
                      <>
                        {validFeedbackData?.map((item) => {
                          return (
                            <div className="additionalContentWrap my-3">
                              <div className="d-flex align-items-center mt-2 mb-3">
                                {item?.user?.profile_image ? (
                                  <img
                                    src={item?.user?.profileImage}
                                    alt={item?.userName}
                                  />
                                ) : (
                                  <img
                                    src={sampleProfile}
                                    alt="profile"
                                    className="reviewProfileImage"
                                  />
                                )}
                                <div className="answeredMemberName mx-3">
                                  {item?.userName}
                                </div>
                              </div>
                              <label className="additionalTitle">Comments</label>
                              <ReactQuill
                                theme="snow"
                                value={item?.comments || ""}
                                readOnly={true}
                                placeholder="Enter your feedback here..."
                                className="styled-quill-editor"
                                modules={{
                                  toolbar: [
                                    [{ header: [1, 2, 3, false] }],
                                    ["bold", "italic", "underline"],
                                    [{ list: "ordered" }, { list: "bullet" }],
                                    ["clean"],
                                  ],
                                }}
                                formats={[
                                  "header",
                                  "bold",
                                  "italic",
                                  "underline",
                                  "list",
                                  // "bullet",
                                ]}
                              />

                              <div>
                                <label className="additionalTitle">Ratings</label>
                                <div className="additionalComments">
                                  <div className="star-rating">
                                    {[1, 2, 3, 4, 5].map(star => (
                                      <span
                                        key={star}
                                        className={`star ${hoveredRatingForModule !== null
                                          ? star <= hoveredRatingForModule ? "hovered" : ""
                                          : star <= (item?.rating || 0) ? "filled" : ""
                                          }`}
                                        onMouseLeave={() => setHoveredRatingForModule(null)}
                                        disabled={true}
                                      >
                                        ★
                                      </span>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </>
                    ) : (
                      <div>No Feedback Added</div>
                    )}
                  </div>
                </>
              )
                :
                (
                  <>
                    {categories[categoryIndex]?.sub_categories[
                      subCategoryIndex
                    ]?.questions?.map((item, questionIndex) => {
                      if (!Array.isArray(item.evidence) || item.evidence.length === 0) {
                        item.evidence = [{ files: [], description: "" }];
                      }

                      if (!Array.isArray(item.recommendation) || item.recommendation.length === 0) {
                        item.recommendation = [{ files: [], recText: "" }];
                      }

                      const groupedData = groupUserAnswers(item)
                      const flattenedData = Object.values(groupedData).flat();
                      const lastOccurrenceMap = new Map();
                      flattenedData.forEach((answer, index) => {
                        lastOccurrenceMap.set(answer.user_id, index);
                      });
                      return (
                        <div key={questionIndex}>
                          <div className="question">
                            {item?.question_id}. <span>{item?.question}</span>
                          </div>
                          <div className="answer-wrap my-3">
                            {item?.userAnswer?.length > 0 ? (
                              <div>
                                {Object.entries(groupedData).map(([userId, answers]) => (
                                  <div key={userId} style={{ marginBottom: "2rem" }}>
                                    <div className="d-flex align-items-center my-2">
                                      {answers[0]?.user?.profile_image ? (
                                        <img
                                          src={answers[0].user.profile_image}
                                          alt={answers[0].user_name}
                                          className="reviewProfileImage"
                                        />
                                      ) : (
                                        <img src={sampleProfile} alt="profile" className="reviewProfileImage" />
                                      )}
                                      <div className="answeredMemberName mx-4">{answers[0].user_name}</div>
                                    </div>
                                    <div className="user-answer-flex-container" style={{ display: "flex", gap: "1rem", flexWrap: "wrap", flexDirection: "column" }}>
                                      {answers.map((list, index) => (
                                        <div key={index} className="user-answer-card">
                                          <div>
                                            {/* <div className="d-flex align-items-center my-2">
                                              {list?.user?.profile_image ? (
                                                <img
                                                  src={list.user.profile_image}
                                                  alt={list.user_name}
                                                  className="reviewProfileImage"
                                                />
                                              ) : (
                                                <img src={sampleProfile} alt="profile" className="reviewProfileImage" />
                                              )}
                                              <div className="answeredMemberName mx-4">{list.user_name}</div>
                                              <div className="answeredMemberName">{list.points}</div>
                                            </div> */}

                                            {list.bearing_size && (
                                              <div>
                                                {list.bearing_size} (
                                                {list.bearing_size === "small"
                                                  ? "<55mm"
                                                  : list.bearing_size === "medium"
                                                    ? "55mm - 200mm"
                                                    : ">200mm"}
                                                )
                                              </div>
                                            )}

                                            <div
                                              style={{
                                                color:
                                                  item?.field_type === "rearrange"
                                                    ? list?.points === 1
                                                      ? "#5df380"
                                                      : "#e94f45"
                                                    : "",
                                              }}
                                            >
                                              {getGreaseInfo(list) ? (
                                                <>
                                                  {getAnswerText(list)}
                                                  <br />
                                                  {getGreaseInfo(list)}
                                                </>
                                              ) : (
                                                getAnswerText(list)
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>

                                    {/* Notes after user's answers */}
                                    <div style={{ marginTop: "0.5rem", width: "100%", textAlign: "left" }}>
                                      <div className="answeredMemberName my-2">Notes</div>
                                      <div>{answers[0]?.notes}</div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <>
                                <div className="d-flex align-items-center">
                                  <span className="message">User input not needed/ No answers</span>
                                </div>
                              </>
                            )}
                          </div>
                          {(item?.is_scorable && item?.userAnswer?.length > 0) &&
                            <>
                              <div className="answer-wrap">
                                {/* <label className="addLabel">Add your Research's here</label> */}
                                <label className="uploadLabel">Add Observation</label>
                                <div className="mt-2">
                                  <ReactQuill
                                    theme="snow"
                                    readOnly={disabled}
                                    value={item?.observation || ""}
                                    onChange={(content) =>
                                      handleChange(
                                        questionIndex,
                                        { target: { value: content } },
                                        "observation"
                                      )
                                    }
                                    placeholder="Enter here"
                                    className="styled-quill-editor"
                                    modules={{
                                      toolbar: [
                                        [{ header: [1, 2, 3, false] }],
                                        ["bold", "italic", "underline"],
                                        [{ list: "ordered" }, { list: "bullet" }],
                                        ["clean"],
                                      ],
                                    }}
                                    formats={[
                                      "header",
                                      "bold",
                                      "italic",
                                      "underline",
                                      "list",
                                      // "bullet",
                                    ]}
                                  />
                                </div>
                                <div className="evidence">
                                  <label className="uploadLabel">Upload Assessment References</label>
                                  {(item?.evidence || [])?.map(
                                    (ev, evidenceIndex) => (
                                      <div className="evidenceDiv" key={evidenceIndex}>

                                        {/* Upload Evidence */}
                                        <div className="evidenceImg">
                                          <div className="filess">
                                            {isLoading === "loading" ? (
                                              <Loader />
                                            ) : (
                                              <FileUploader
                                                disabled={disabled}
                                                multiple={true}
                                                handleChange={(files) =>
                                                  handleFileChange(files, questionIndex, evidenceIndex)
                                                }
                                                name="evidence"
                                                classes="drop_area drop_zone"
                                              >
                                                <p className="drag">
                                                  <span className="mx-2 my-1">
                                                    <img src={uploadIcon} alt="upload" />
                                                  </span>
                                                  Drag your file here or upload to
                                                  <span className="here mx-2">Browse</span>
                                                </p>
                                              </FileUploader>
                                            )}

                                            <div className="my-2 uploadNote">
                                              Note: Only images (JPG, JPEG, PNG), PDFs, Word documents (DOCX), and
                                              Excel files (XLSX) are allowed. File size must not exceed 5MB.
                                            </div>
                                          </div>
                                          <div className="error-message">
                                            {
                                              formMethods.formState.errors?.categories?.[categoryIndex]?.sub_categories?.[subCategoryIndex]?.questions?.[questionIndex]?.evidence?.[evidenceIndex]?.message
                                            }
                                          </div>
                                          <div className="uploaded-files">
                                            {ev?.files?.map((fileUrl, fileIndex) => {
                                              const fileName =
                                                typeof fileUrl === "string"
                                                  ? fileUrl.split("/").pop()?.split("---").pop()
                                                  : `File ${fileIndex + 1}`;

                                              return (
                                                <div key={fileIndex} className="file-item">
                                                  <span className="me-2">{decodeURIComponent(fileName)}</span>
                                                  <MdDeleteOutline
                                                    onClick={() =>
                                                      handleRemoveFile(questionIndex, fileIndex, evidenceIndex)
                                                    }
                                                    color="#1f2155"
                                                    size={25}
                                                    className="remove-icon"
                                                  />
                                                </div>
                                              );
                                            })}
                                          </div>
                                        </div>

                                        {/* Evidence Description */}
                                        <div className="evidenceDescription">
                                          <div className="mt-2">
                                            <ReactQuill
                                              ref={(el) => {
                                                if (el) {
                                                  quillRefs.current[evidenceIndex] = el;
                                                  const quill = el.getEditor();

                                                  const handler = () => {
                                                    const text = quill.getText().trimEnd();
                                                    if (text.length > MAX_CHARS) {
                                                      quill.deleteText(MAX_CHARS, text.length);
                                                    }
                                                  };

                                                  quill.off("text-change", handler);
                                                  quill.on("text-change", handler);
                                                }
                                              }}
                                              theme="snow"
                                              readOnly={disabled}
                                              value={ev?.description || ""}
                                              onChange={(content) => {
                                                handleChange(
                                                  questionIndex,
                                                  { target: { value: content } },
                                                  "evidence",
                                                  evidenceIndex,
                                                  "description"
                                                )
                                              }}
                                              placeholder="Enter here (max 100 characters)..."
                                              className="styled-quill-editor"
                                            />

                                          </div>
                                          <div className="blockButtons">
                                            <Button
                                              title="Add New Assessment Reference"
                                              titleStyle={buttonTitleStyle}
                                              buttonStyle={buttonStyle}
                                              forForm={true}
                                              onClick={() => handleAddEvidence(questionIndex)}
                                            />
                                            {evidenceIndex > 0 && (
                                              <Button
                                                title="Delete"
                                                titleStyle={buttonTitleStyle}
                                                buttonStyle={buttonStyle}
                                                forForm={true}
                                                onClick={() => handleDeleteItem(questionIndex, evidenceIndex)}
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>

                                <div>
                                  <label className="uploadLabel">Add Insights</label>
                                  <div className="mt-2">
                                    <ReactQuill
                                      theme="snow"
                                      readOnly={disabled}
                                      value={item?.insights || ""}
                                      onChange={(content) =>
                                        handleChange(
                                          questionIndex,
                                          { target: { value: content } },
                                          "insights"
                                        )
                                      }
                                      placeholder="Enter here"
                                      className="styled-quill-editor"
                                      modules={{
                                        toolbar: [
                                          [{ header: [1, 2, 3, false] }],
                                          ["bold", "italic", "underline"],
                                          [{ list: "ordered" }, { list: "bullet" }],
                                          ["clean"],
                                        ],
                                      }}
                                      formats={[
                                        "header",
                                        "bold",
                                        "italic",
                                        "underline",
                                        "list",
                                        // "bullet",
                                      ]}
                                    />
                                  </div>
                                </div>
                                <div className="evidence">
                                  <label className="addLabel-recommendation">Add Recommendations</label>

                                  {(item?.recommendation || [])?.map((rec, recIndex) => (
                                    <div className="evidenceDiv" key={recIndex} style={{ flexDirection: "column" }}>
                                      <div className="evidenceImg" style={{ width: "100%" }}>
                                        {/* <label className="uploadLabel">Upload Evidence</label> */}
                                        <div className="filess">
                                          {isLoading === "loading" ? (
                                            <Loader />
                                          ) : (
                                            <FileUploader
                                              disabled={disabled}
                                              multiple={true}
                                              handleChange={(files) =>
                                                handleFileChange(files, questionIndex, recIndex, true)
                                              }
                                              name="evidence"
                                              classes="drop_area drop_zone"
                                            >
                                              <p className="drag">
                                                <span className="mx-2 my-1">
                                                  <img src={uploadIcon} alt="upload" />
                                                </span>
                                                Drag your file here or upload to
                                                <span className="here mx-2">Browse</span>
                                              </p>
                                            </FileUploader>
                                          )}

                                          <div className="my-2 uploadNote">
                                            Note: Only images (JPG, JPEG, PNG), PDFs, Word documents (DOCX), and
                                            Excel files (XLSX) are allowed. File size must not exceed 5MB.
                                          </div>
                                        </div>

                                        <div className="error-message">
                                          {
                                            formMethods.formState.errors?.categories?.[categoryIndex]?.sub_categories?.[subCategoryIndex]?.questions?.[questionIndex]?.recommendation?.[recIndex]?.message
                                          }
                                        </div>
                                        <div className="uploaded-files">
                                          {rec?.files?.map((fileUrl, fileIndex) => {
                                            const fileName =
                                              typeof fileUrl === "string"
                                                ? fileUrl.split("/").pop()?.split("---").pop()
                                                : `File ${fileIndex + 1}`;

                                            return (
                                              <div key={fileIndex} className="file-item">
                                                <span className="me-2">{decodeURIComponent(fileName)}</span>
                                                <MdDeleteOutline
                                                  onClick={() =>
                                                    handleRemoveFile(questionIndex, fileIndex, recIndex, true)
                                                  }
                                                  color="#1f2155"
                                                  size={25}
                                                  className="remove-icon"
                                                />
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                      <div className="evidenceDescription" style={{ width: "100%" }}>
                                        <div key={recIndex} className="styled-quill-wrapper">
                                          <ReactQuill
                                            theme="snow"
                                            readOnly={disabled}
                                            value={rec?.recText}
                                            onChange={(content) =>
                                              handleChange(
                                                questionIndex,
                                                { target: { value: content } },
                                                "recommendation",
                                                recIndex,
                                                "recText"
                                              )
                                            }
                                            // onChange={(content) => handleRecommendation({ target: { value: content } }, questionIndex, recIndex)}
                                            placeholder="Enter Recommendation"
                                            className="styled-quill-editor"
                                            modules={{
                                              toolbar: [
                                                [{ header: [1, 2, 3, false] }],
                                                ["bold", "italic", "underline"],
                                                [{ list: "ordered" }, { list: "bullet" }],
                                                ["clean"],
                                              ],
                                            }}
                                            formats={[
                                              "header",
                                              "bold",
                                              "italic",
                                              "underline",
                                              "list",
                                              // "bullet",
                                            ]}
                                          />


                                        </div>
                                        <div className="blockButtons">
                                          <Button
                                            title="Add New Recommendation"
                                            titleStyle={buttonTitleStyle}
                                            buttonStyle={buttonRecommendationStyle}
                                            forForm={true}
                                            onClick={() => handleAddRecommendation(questionIndex)}
                                          />
                                          {recIndex > 0 && (
                                            <Button
                                              title="Delete"
                                              titleStyle={buttonTitleStyle}
                                              buttonStyle={buttonStyle}
                                              forForm={true}
                                              onClick={() => handleDeleteItem(questionIndex, recIndex, true)}
                                            />
                                          )}
                                        </div>

                                      </div>
                                    </div>
                                  ))}
                                </div>

                              </div>
                              <div className="answer-wrap my-3">
                                {/* Approver Feedback Section */}
                                {item?.isApproverFeedback && (
                                  <div className="approverFeedbackSection mt-4">
                                    <label className="uploadLabel">Approver Feedback</label>
                                    <div className="approverFeedbackContent"
                                      dangerouslySetInnerHTML={{ __html: item?.approverFeedback ?? "" }}>
                                    </div>

                                    {/* Approver Feedback Uploads */}
                                    {/* {item?.approverFeedbackUpload && item.approverFeedbackUpload.length > 0 && ( */}
                                    <div className="approverFeedbackUploads mt-3">
                                      <label className="uploadLabel">Uploaded Files</label>
                                      <div className="uploaded-files-grid">
                                        {item?.approverFeedbackUpload?.map((fileUrl, fileIndex) => {
                                          const isPDF = fileUrl.toLowerCase().endsWith(".pdf");
                                          const isDoc = fileUrl.toLowerCase().endsWith(".docx");
                                          const isXls = fileUrl.toLowerCase().endsWith(".xlsx");

                                          return (
                                            <div key={fileIndex} className="my-2">
                                              {isPDF ? (
                                                <div className="pdf-container">
                                                  <div className="individual-pdf-container">
                                                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                      <img src={PDFIcom} alt="PDF" width="75px" height="auto" />
                                                      <p>Open PDF</p>
                                                    </a>
                                                  </div>
                                                </div>
                                              ) : isDoc ? (
                                                <div className="pdf-container">
                                                  <div className="individual-pdf-container">
                                                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                      <img src={DocIcon} alt="Doc" width="75px" height="auto" />
                                                      <p>Open Doc</p>
                                                    </a>
                                                  </div>
                                                </div>
                                              ) : isXls ? (
                                                <div className="pdf-container">
                                                  <div className="individual-pdf-container">
                                                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                      <img src={XlsIcon} alt="Xlsx" width="75px" height="auto" />
                                                      <p>Open Xlsx</p>
                                                    </a>
                                                  </div>
                                                </div>
                                              ) : (
                                                <ImageModal src={fileUrl} alt={`approver-file-${fileIndex}`} />
                                              )}
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                    {/* )} */}
                                  </div>
                                )}
                              </div>
                              <div>
                                <label className="finalScoreLabel">Final Score</label>
                                <div className="d-flex align-items-center">
                                  {[1, 2, 3, 4, 5].map((score, index) => (
                                    <div
                                      key={index}
                                      className={`finalScoreValue ms-2 ${getScoreClass(
                                        score,
                                        questionIndex
                                      )}`}
                                      onClick={(!disabled) ? () => handleFinalScore(score, questionIndex) : () => { }}                        >
                                      {score}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </>
                          }
                          {selectedFile && (
                            <div className="modalOverlay">
                              <div className="modalContent">
                                <ImageEditorComp
                                  file={selectedFile}
                                  onSave={(editedFile) => {
                                    uploadFiles([editedFile], uploadContext);
                                    setSelectedFile(null);
                                    setUploadContext(null);
                                  }}
                                  onClose={() => {
                                    setSelectedFile(null);
                                    setUploadContext(null);
                                  }}
                                />

                              </div>
                            </div>

                          )}

                        </div>
                      );
                    })}
                  </>
                )}
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>

  );
};

export default AssessmentAnswer;
